<div class="new-ec-representative-container">
    <form [formGroup]="form" fxLayout="column" (keydown.enter)="false">
        <mat-horizontal-stepper [linear]="true" [disableRipple]="true" fxLayout="column" class="stepper" #stepper>
            <ng-template matStepperIcon="edit" let-index="index">
                {{ index + 1 }}
            </ng-template>
            <mat-step *ngIf="tenants.length > 1" [completed]="form.controls.tenant.value">
                <ng-template matStepLabel>
                    <span class="title">{{ 'Choose client'|i18n }}</span>
                </ng-template>
                <div class="main-title mt-32">
                    {{ 'Choose your representative\'s client'|i18n }}
                </div>
                <div fxLayout="column" fxLayoutGap="24px" class="form mt-32">
                    <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="24px">
                        <div fxLayoutAlign="end" fxFlex="30">{{ 'Client'|i18n }}:</div>
                        <mat-select app-small-select placeholder="{{'Select client'|i18n}}"
                                    formControlName="tenant" (selectionChange)="onSelectTenant($event)">
                            <mat-option *ngFor="let ten of tenants | keyvalue"
                                        [value]="ten.value">
                                {{ ten.value.name }}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-48">
                    <button app-ghost-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                            [mat-dialog-close]="false">
                        <app-icon name="fal-times"></app-icon>
                        <span>{{ 'Cancel'|i18n }}</span>
                    </button>
                    <button app-primary-button matStepperNext fxLayoutAlign="space-around center" fxLayoutGap="16px"
                            [disabled]="!form.controls.tenant.value">
                        <span>{{ 'Proceed'|i18n }}</span>
                        <app-icon class="no-margin" name="fal-arrow-right"></app-icon>
                    </button>
                </div>
            </mat-step>
            <mat-step [completed]="isFirstPageValid">
                <ng-template matStepLabel>
                    <span class="title">{{ 'Create account_{a}'|i18n }}</span>
                </ng-template>
                <div class="main-title mt-32">
                    {{ 'Create new representative account'|i18n }}
                </div>
                <div fxLayout="column" fxLayoutGap="24px" class="form mt-32">
                    <div fxLayout="column" fxLayoutGap="24px">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="22">{{ ('Name'|i18n) + ':*' }}</div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="firstName" [maxLength]="NAME_MAX_CHARS">
                                <div *ngIf="isControlOK('firstName')" app-error>{{ 'Invalid name'|i18n }}</div>
                            </div>
                            <div fxFlex="22"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="22">{{ ('Last name'|i18n) + ':*' }}</div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="lastName" [maxLength]="NAME_MAX_CHARS">
                                <div *ngIf="isControlOK('lastName')" app-error>{{ 'Invalid last name'|i18n }}</div>
                            </div>
                            <div fxFlex="22"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end"
                                 fxFlex="22">{{ ('Email (username)'|i18n) + ':*' }}
                            </div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="email" [maxLength]="EMAIL_MAX_CHARS">
                                <ng-container *ngIf="isControlOK('email')">
                                    <div *ngIf="uniqueEmailError" app-error>{{ 'E-mail already exists'|i18n }}</div>
                                    <div *ngIf="!uniqueEmailError" app-error>{{ 'Invalid email'|i18n }}</div>
                                </ng-container>
                            </div>
                            <div fxFlex="22"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="22">{{ ('Confirm email'|i18n) + ':*' }}
                            </div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="confirmEmail" (paste)="false" (copy)="false"
                                       (cut)="false" [maxLength]="EMAIL_MAX_CHARS">
                                <ng-container *ngIf="isControlOK('confirmEmail')">
                                    <div *ngIf="notMatchingEmails" app-error>{{ 'E-mails do not match'|i18n }}</div>
                                    <div *ngIf="!notMatchingEmails" app-error>{{ 'Invalid email'|i18n }}</div>
                                </ng-container>
                            </div>
                            <div fxFlex="22"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="22"
                                 class="t-right">{{ ('Mobile'|i18n) + ':*' }}
                            </div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="mobileNumber" [maxLength]="MOBILE_MAX_CHARS">
                                <div *ngIf="isControlOK('mobileNumber')"
                                     app-error>{{ 'Invalid mobile number'|i18n }}
                                </div>
                            </div>
                            <div fxFlex="22"></div>
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutGap="24px">
                        <div fxLayout="row" fxLayoutAlign="space-around">
                            <div class="title-2 mt-24">
                                {{ 'Account security'|i18n }}
                            </div>
                            <div fxFlex="22"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end start"
                                 fxFlex="22">{{ ('Single-use password'|i18n) + ':*' }}
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="4px" app-input-container
                                 fxFlex>
                                <div fxLayout="column" fxLayoutGap="2px" fxFlex="90">
                                    <input app-input autocomplete="off" [type]="hidePwd ? 'password' : 'text'"
                                           formControlName="password" [maxLength]="DEFAULT_MAX_CHARS">
                                    <div [ngClass]="strength.clazz">
                                        <mat-progress-bar class="progress-bar" ngClass.lt-lg="progress-bar-mobile"
                                                          [mode]="'determinate'" [value]="strength.quality">
                                        </mat-progress-bar>
                                    </div>
                                    <mat-error *ngIf="messages.length > 0 || pwContainsForbiddenWords"
                                               class="form-text text-danger invalid-field mb-10">
                                        {{ 'New password should'|i18n }}:
                                        <div *ngFor="let msg of messages" fxLayout="column">
                                            <span class="text-danger">- {{ (msg.message|i18n:msg.argument) }}</span>
                                        </div>
                                        <div *ngIf="pwContainsForbiddenWords" class="text-danger">
                                            - {{ 'not contain first name, last name or e-mail'|i18n }}
                                        </div>
                                    </mat-error>
                                </div>
                                <button mat-icon-button matSuffix type="button" tabindex="-1" fxFlex="10"
                                        (click)="hidePwd = !hidePwd"
                                        [attr.aria-label]="('Hide password'|i18n)"
                                        [attr.aria-pressed]="hidePwd">
                                    <mat-icon>{{ hidePwd ? 'visibility_off' : 'visibility' }}</mat-icon>
                                </button>
                            </div>
                            <div fxFlex="22"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end"
                                 fxFlex="22">{{ ('Repeat password_{a}'|i18n) + ':*' }}
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="4px" app-input-container
                                 fxFlex>
                                <div fxFlex="90" app-input-container>
                                    <input app-input [type]="hideRepeatedPwd ? 'password' : 'text'" autocomplete="off"
                                           formControlName="confirmPassword" [maxLength]="DEFAULT_MAX_CHARS">
                                    <ng-container *ngIf="isControlOK('confirmPassword')">
                                        <div *ngIf="notMatchingPasswords"
                                             app-error>{{ 'Passwords do not match'|i18n }}
                                        </div>
                                        <div *ngIf="!notMatchingPasswords" app-error>{{ 'Invalid password'|i18n }}</div>
                                    </ng-container>
                                </div>
                                <button mat-icon-button matSuffix type="button" tabindex="-1" fxFlex="10"
                                        (click)="hideRepeatedPwd = !hideRepeatedPwd"
                                        [attr.aria-label]="('Hide password'|i18n)"
                                        [attr.aria-pressed]="hideRepeatedPwd">
                                    <mat-icon>{{ hideRepeatedPwd ? 'visibility_off' : 'visibility' }}</mat-icon>
                                </button>
                            </div>
                            <div fxFlex="22"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-around">
                            <div class="title-3">
                                <mat-slide-toggle formControlName="enable2FA" app-toggle>
                                    <span class="ml-12">{{ 'Enable 2FA'|i18n }}</span>
                                </mat-slide-toggle>
                            </div>
                            <div fxFlex="5"></div>
                        </div>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-48">
                    <button *ngIf="tenants.length <= 1" app-ghost-button fxLayoutAlign="space-around center"
                            fxLayoutGap="16px" [mat-dialog-close]="false">
                        <app-icon name="fal-times"></app-icon>
                        <span>{{ 'Cancel'|i18n }}</span>
                    </button>
                    <button *ngIf="tenants.length > 1" matStepperPrevious app-ghost-button
                            fxLayoutAlign="space-around center" fxLayoutGap="16px">
                        <app-icon name="fal-arrow-left"></app-icon>
                        <span>{{ 'Back'|i18n }}</span>
                    </button>
                    <button app-primary-button matStepperNext fxLayoutAlign="space-around center" fxLayoutGap="16px"
                            [disabled]="!isFirstPageValid">
                        <span>{{ 'Proceed'|i18n }}</span>
                        <app-icon class="no-margin" name="fal-arrow-right"></app-icon>
                    </button>
                </div>
            </mat-step>
            <mat-step
                    [completed]="isSecondPageValid && ((stepper.selectedIndex === 2 && tenants.length > 1) || (stepper.selectedIndex === 1 && tenants.length === 1))">
                <ng-template matStepLabel>
                    <span class="title">{{ 'Biographical data'|i18n }}</span>
                </ng-template>
                <div class="main-title mt-32">
                    {{ 'Biographical data'|i18n }}
                </div>
                <div fxLayout="column" fxLayoutGap="24px" class="form mt-32">
                    <div fxLayout="column" fxLayoutGap="24px">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end"
                                 fxFlex="22">{{ ('Representative type'|i18n) + ':*' }}
                            </div>
                            <mat-select app-small-select formControlName="representativeType">
                                <mat-option *ngFor="let subject of ECRepresentativeType | keyvalue"
                                            [value]="subject.value">
                                    {{ subject.value|genericPipe }}
                                </mat-option>
                            </mat-select>
                            <div *ngIf="isControlOK('representativeType')" app-error>{{ 'Invalid type'|i18n }}</div>
                            <div fxFlex="22"></div>
                        </div>
                        <div *ngIf="(form.controls.representativeType.value === ECRepresentativeType.PUBLIC_INSTITUTION) ||
                                    (form.controls.representativeType.value === ECRepresentativeType.PRIVATE_INSTITUTION)"
                             fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="22">{{ ('Company name'|i18n) + ':*' }}</div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="companyName" [maxLength]="DEFAULT_MAX_CHARS">
                                <div *ngIf="isControlOK('companyName')" app-error>{{ 'Invalid company name'|i18n }}
                                </div>
                            </div>
                            <div fxFlex="22"></div>
                        </div>
                        <div *ngIf="form.controls.representativeType.value === ECRepresentativeType.NATURAL_PERSON"
                             fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="22">{{ ('Fiscal code'|i18n) + ':' }}</div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="taxId" [maxLength]="TAX_ID_MAX_CHARS">
                                <div *ngIf="isControlOK('taxId')" app-error>{{ 'Invalid fiscal code'|i18n }}</div>
                            </div>
                            <div fxFlex="22"></div>
                        </div>
                        <div *ngIf="(form.controls.representativeType.value === ECRepresentativeType.PUBLIC_INSTITUTION) ||
                                    (form.controls.representativeType.value === ECRepresentativeType.PRIVATE_INSTITUTION)"
                             fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="22">{{ ('P. IVA'|i18n) + ':' }}</div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="vatNumber" [maxLength]="VAT_NUMBER_MAX_CHARS">
                                <div *ngIf="isControlOK('vatNumber')" app-error>{{ 'Invalid P. IVA'|i18n }}</div>
                            </div>
                            <div fxFlex="22"></div>
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutGap="24px">
                        <div fxLayout="row" fxLayoutAlign="space-around">
                            <div class="title-2 mt-24">
                                {{ 'Address'|i18n }}
                            </div>
                            <div fxFlex="22"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayoutAlign="end"
                                 fxFlex="22">{{ ('Address'|i18n) + ':' }}
                            </div>
                            <div fxFlex>
                                <app-google-maps-address-autocomplete [formControlRef]="addressFormControl"
                                                                      [isRequired]="false"
                                                                      [requiresGooglePlace]="false"
                                                                      (addressChange)="addressChange($event)"
                                                                      [restrictSearch]="true">
                                </app-google-maps-address-autocomplete>
                            </div>
                            <div fxFlex="22"></div>
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutGap="24px">
                        <div fxLayout="row" fxLayoutAlign="space-around">
                            <div class="title-2 mt-24">
                                {{ 'Contacts'|i18n }}
                            </div>
                            <div fxFlex="22"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end"
                                 fxFlex="22">{{ ('Phone'|i18n) + ':' }}
                            </div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="telephone" [maxLength]="MOBILE_MAX_CHARS">
                                <div *ngIf="isControlOK('telephone')"
                                     app-error>{{ 'Invalid telephone number'|i18n }}
                                </div>
                            </div>
                            <div fxFlex="22"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end"
                                 fxFlex="22">{{ ('PEC'|i18n) + ':' }}
                            </div>
                            <div fxFlex app-input-container>
                                <input app-input formControlName="pec" [maxLength]="EMAIL_MAX_CHARS">
                                <div *ngIf="isControlOK('pec')" app-error>{{ 'Invalid PEC'|i18n }}</div>
                            </div>
                            <div fxFlex="22"></div>
                        </div>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-48">
                    <button app-ghost-button matStepperPrevious fxLayoutAlign="space-around center" fxLayoutGap="16px">
                        <app-icon name="fal-arrow-left"></app-icon>
                        <span>{{ 'Back'|i18n }}</span>
                    </button>
                    <button app-primary-button matStepperNext fxLayoutAlign="space-around center" fxLayoutGap="16px"
                            [disabled]="!isSecondPageValid">
                        <span>{{ 'Proceed'|i18n }}</span>
                        <app-icon class="no-margin" name="fal-arrow-right"></app-icon>
                    </button>
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>
                    <span class="title">{{ 'Assign communities'|i18n }}</span>
                </ng-template>
                <div class="main-title mt-32">
                    {{ 'Assign communities to {0}'|i18n:formFullName(form) }}
                </div>
                <div fxLayout="column" fxLayoutGap="24px" class="form mt-32">
                    <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="24px">
                        <div fxFlex="30">{{ 'Select one or more communities'|i18n }}:</div>
                        <div fxFlex="60"
                             fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px">
                            <mat-form-field class="more-width">
                                <mat-label>
                                    {{ 'Communities'|i18n }}
                                </mat-label>
                                <input type="text"
                                       placeholder="{{freeCommsForTenant.length > 0 ? ('Select community'|i18n) : ('No communities available'|i18n)}}"
                                       aria-label="Number" matInput [spellcheck]="false"
                                       [formControl]="freeCommsFilter" [matAutocomplete]="auto">
                                <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option *ngFor="let comm of arrSelectableComms | keyvalue:sortByName"
                                                [value]="comm.value.name"
                                                (onSelectionChange)="onSelectCommunity($event)">
                                        {{ comm.value.name }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                            <button app-primary-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                                    [disabled]="!tempC" (click)="onAddCommunity(form.controls.tenant.value)">
                                <span>{{ 'Add community'|i18n }}</span>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="assignations.length > 0" fxLayout="row wrap" fxLayoutAlign="center" fxLayoutGap="12px">
                        <div *ngFor="let ass of assignations">
                            <button app-small-ghost-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                                    (click)="removeAssignation(ass, form.controls.tenant.value)" class="grey-btn mb-12">
                                <span>{{ ass.name }}</span>
                                <div class="grey-box">
                                    <app-icon class="no-margin grey-icon" name="fal-times"></app-icon>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="assignations.length === 0" fxLayout="row" fxLayoutAlign="center">
                        <div class="grey-text">{{ 'No communities assigned'|i18n }}.</div>
                    </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="space-between center" fxLayoutGap="24px" class="mt-48">
                    <button app-primary-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                            (click)="sendRepresentative(true)" [disabled]="assignations.length === 0 || !form.valid">
                        <app-icon name="fal-save"></app-icon>
                        <span>{{ 'Save assignments'|i18n }}</span>
                    </button>
                    <span>{{ 'or'|i18n }}</span>
                    <button app-ghost-button fxLayoutAlign="space-around center" fxLayoutGap="16px"
                            (click)="sendRepresentative(false)" [disabled]="!form.valid">
                        <span>{{ 'Assign in the future'|i18n }}</span>
                        <app-icon class="no-margin" name="fal-arrow-right"></app-icon>
                    </button>
                    <div class="mild-text">{{ 'Save representative without any assigned communities'|i18n }}.</div>
                </div>
                <div fxLayoutAlign="start center" class="mt-12">
                    <button matStepperPrevious app-ghost-button
                            fxLayoutAlign="space-around center" fxLayoutGap="16px">
                        <app-icon name="fal-arrow-left"></app-icon>
                        <span>{{ 'Back'|i18n }}</span>
                    </button>
                </div>
            </mat-step>
        </mat-horizontal-stepper>
    </form>
</div>
